import { useCallback } from "react";
import useMixpanelPromotionPeople from "./useMixpanelPromotionPeople";
import {
  processSingleSelection,
  processMultiSelection,
  processQAResponses,
} from "../utils/promotionMixpanelHelper";

/**
 * Hook to track promotion onboarding selections to Mixpanel User Properties
 */
export function usePromotionOnboardingTracking(pageKey: string) {
  const setPromotionPeople = useMixpanelPromotionPeople();

  const trackSingleSelection = useCallback(
    (singleSelectionId: number) => {
      const properties = processSingleSelection({
        pageKey,
        singleSelectionId,
      });
      if (properties) {
        setPromotionPeople(properties);
      }
    },
    [pageKey, setPromotionPeople]
  );

  const trackMultiSelection = useCallback(
    (multiSelectionIdList: number[]) => {
      const properties = processMultiSelection({
        pageKey,
        multiSelectionIdList,
      });
      if (properties) {
        setPromotionPeople(properties);
      }
    },
    [pageKey, setPromotionPeople]
  );

  const trackQAResponses = useCallback(
    (qaList: Array<{ answerId: number }>) => {
      const properties = processQAResponses({
        pageKey,
        qaList,
      });
      if (properties) {
        setPromotionPeople(properties);
      }
    },
    [pageKey, setPromotionPeople]
  );

  return {
    trackSingleSelection,
    trackMultiSelection,
    trackQAResponses,
  };
}
